import { Package, ShoppingCart, Users, Banknote } from "lucide-react";
import { formatRON } from "@/lib/api";

export default function AnalyticsDashboard({ stats }) {
  const statCards = stats ? [
    { icon: Banknote, label: "Venituri", value: formatRON(stats.revenue) },
    { icon: ShoppingCart, label: "Comenzi", value: stats.orders },
    { icon: Package, label: "Produse", value: stats.products },
    { icon: Users, label: "Clienți", value: stats.customers },
  ] : [];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12" data-testid="admin-analytics">
      {statCards.map((s, i) => (
        <div key={s.label} className="border border-slate-200 p-6" data-testid={`stat-${i}`}>
          <s.icon className="w-6 h-6 text-orange-600" />
          <div className="text-2xl font-black mt-3">{s.value}</div>
          <div className="text-xs uppercase tracking-wide text-slate-500">{s.label}</div>
        </div>
      ))}
    </div>
  );
}
